module.exports = __webpack_public_path__ + "static/media/suspension.8d183c30.svg";